import React, { useState, useEffect } from 'react';
import axios from '../api/axios';

export default function BirthdaySection() {
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [branchFilter, setBranchFilter] = useState('');

  useEffect(() => {
    fetchBirthdays();
  }, []);

  const fetchBirthdays = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/birthdays/upcoming');
      
      if (response.data.success) {
        // Filter to only show D-60 and beyond (next 60 days)
        let filtered = response.data.data.filter(birthday => birthday.daysUntilBirthday >= 0 && birthday.daysUntilBirthday <= 60);
        
        // Sort by D-day (ascending order)
        filtered.sort((a, b) => a.daysUntilBirthday - b.daysUntilBirthday);
        
        setBirthdays(filtered);
      } else {
        setBirthdays([]);
      }
    } catch (error) {
      setBirthdays([]);
    } finally {
      setLoading(false);
    }
  };

  const getDDayMessage = (daysUntil) => {
    if (daysUntil === 0) return 'D-Day 🎂';
    if (daysUntil === 1) return 'D-1';
    if (daysUntil <= 7) return `D-${daysUntil}`;
    return `D-${daysUntil}`;
  };

  const branchOptions = [
    { value: '', label: 'All Branches' },
    { value: 'NCCU', label: 'NCCU' },
    { value: 'NTU', label: 'NTU' },
    { value: 'TAIPEI', label: 'TAIPEI' }
  ];

  const filteredBirthdays = branchFilter 
    ? birthdays.filter(b => b.branch === branchFilter)
    : birthdays;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-bold text-gray-900 flex items-center">
          🎂 Staff Birthdays
        </h2>
        <select
          value={branchFilter}
          onChange={(e) => setBranchFilter(e.target.value)}
          className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {branchOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className="text-sm text-gray-600 mb-3">
        Next 60 Days
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-4 flex-grow">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        </div>
      ) : filteredBirthdays.length === 0 ? (
        <p className="text-sm text-gray-500 text-center py-4 flex-grow flex items-center justify-center">
          {branchFilter ? `No birthdays in ${branchFilter}` : 'No birthdays in the next 60 days.'}
        </p>
      ) : (
        <div className="space-y-2 flex-grow overflow-y-auto max-h-[500px]">
          {filteredBirthdays.map((birthday, index) => (
            <div
              key={`${birthday.userId}-${index}`}
              className="flex items-center justify-between p-3 bg-pink-50 rounded-lg border border-pink-200"
            >
              <div className="flex items-center space-x-3">
                <div className="text-2xl">
                  🎂
                </div>
                <div>
                  <span className="font-semibold text-gray-900">{birthday.name}</span>
                  <span className="text-xs text-gray-600 ml-2">({birthday.branch})</span>
                </div>
              </div>
              <div className="text-sm font-semibold text-gray-700">
                {getDDayMessage(birthday.daysUntilBirthday)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
